import { graphql } from "@/lib/gql/__generated__";

export const SEND_SAMPLE_EMAIL_RESERVATION_CANCELED_MUTATION = graphql(`
	mutation TestEmailReservationCanceled($input: TestEmailInput!) {
		testEmailReservationCanceled(input: $input) {
			userErrors
			status
		}
	}
`);
